import { useCallback, useEffect } from 'react';

import {
  createUserInfoMessage,
  POS_MODULE_LOADED_MESSAGE,
  useEnvironment,
} from '@publicisgroupe/p-os-components';

import { useUserContext } from 'contexts/AuthProvider';

export const ModuleCommunication = () => {
  const { userInfo, navData } = useUserContext();
  const { isLoaded } = useEnvironment();

  const postUserInfoMessage = useCallback(() => {
    const userInfoMessage = createUserInfoMessage(
      userInfo.userType,
      userInfo.userName,
      navData as [],
      userInfo.userEmail
    );
    (userInfoMessage as any).claims = userInfo.claims;

    window.postMessage(userInfoMessage, window.location.origin);
  }, [userInfo.userType, userInfo.userName, userInfo.userEmail, userInfo.claims, navData]);

  useEffect(() => {
    postUserInfoMessage();
  }, [postUserInfoMessage]);

  const handleModuleLoadedMessage = useCallback(
    (event: MessageEvent<any>) => {
      if (!isLoaded || event.data.message !== POS_MODULE_LOADED_MESSAGE) return;

      postUserInfoMessage();
    },
    [isLoaded, postUserInfoMessage]
  );

  useEffect(() => {
    window.addEventListener('message', handleModuleLoadedMessage, false);
    return () => {
      window.removeEventListener('message', handleModuleLoadedMessage);
    };
  }, [handleModuleLoadedMessage]);

  return <></>;
};
